import { HttpClient } from  '@angular/common/http';
import {Injectable} from "@angular/core";
import {Observable, of} from "rxjs/index";
import {AuthHttp} from "angular2-jwt";
import {environment} from "../../../environments/environment";
import {BusinessDto} from "../../model/business/dto/business-dto";
@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  public selectedBusinessDTO: BusinessDto;

  constructor(private authHttp: AuthHttp,
              private http: HttpClient) {
  }

  public getTotalSales(businessId: string, startDateIso: string, endDateIso: string): Observable<any> {
    return this.authHttp.get(environment.BACKEND_ROOT_SERVICE + "analytics/total-sales/" + businessId
      + "/" + startDateIso + "/" + endDateIso);
  }

  public getSalesByCategory(businessId: string, startDateIso: string, endDateIso: string): Observable<any> {
    return this.authHttp.get(environment.BACKEND_ROOT_SERVICE + "analytics/sales-by-category/" + businessId
      + "/" + startDateIso + "/" + endDateIso);
  }

  public getOrdersDailyCount(businessId: string, dateIso: string): Observable<any> {
    return this.authHttp.get(environment.BACKEND_ROOT_SERVICE + "analytics/orders-daily-count/" + businessId
      + "/" + dateIso);
  }

  public getTopItemsSold(businessId: string, startDateIso: string, endDateIso: string): Observable<any> {
    return this.authHttp.get(environment.BACKEND_ROOT_SERVICE + "analytics/top-items-sold/" + businessId
      + "/" + startDateIso + "/" + endDateIso);
  }

  public getDateAsString(date: Date) {
    let dateAsString = null;
    if (date != null) {
      const year: any = date.getFullYear();
      let month: any = (date.getMonth() + 1);
      let day: any = date.getDate();

      if (day < 10) {
        day = '0' + day;
      }
      if (month < 10) {
        month = '0' + month;
      }

      dateAsString = year + '-' + month + '-' + day;
    }
    return dateAsString;
  }
}
